interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div className={align === "center" ? "max-w-3xl mx-auto text-center" : "max-w-3xl"}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label tracking-[0.2em] uppercase text-primary-600">
        <span className="w-6 h-px bg-primary-400" />
        {eyebrow}
      </span>
      <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      )}
    </div>
  );
}